import ws from "@/utils/service";
import { useMutation } from "@tanstack/react-query";
import { TContactUs } from "../utils/types";

type TSendUsAMessage = {
  first_name?: string;
  last_name?: string;
  email_address?: string;
  subject?: string;
  message?: string;
  recaptcha?: string;
};

export const initialSendUsAMesage: TSendUsAMessage = {
  first_name: "",
  last_name: "",
  email_address: "",
  subject: "",
  message: "",
  recaptcha: ""
};

const useContactUs = () => {
  return useMutation({
    mutationFn: async ({ payload }: { payload: TContactUs }) => {
      return await ws.post("/api/pub/contactus/submit", payload);
    }
  });
};

export default useContactUs;
